import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Paziente } from '../model/paziente.entity';
import { environment } from 'src/environments/environment';
import { Paged } from '../model/paged.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PazientiService {

  constructor(private http: HttpClient) { }
  public getAllPazienti(search: string, page: number, size: number) {
    let params = new HttpParams()
    .set('search', search)
    .set('page', page.toString())
    .set('size', size.toString());

  return this.http.get<Paged>(environment.backendUrl+'/paziente',{
    params: params,
    headers:{
      "Portal-Type":"military"
    }
  });
  }
  public getPazienteByCf(codiceFiscale: string){
    return this.http.get<Paziente>(environment.backendUrl+'/paziente/find/'+codiceFiscale)
  }
  public savePaziente(paziente: Paziente){
    return this.http.post<Paziente>(environment.backendUrl+'/paziente/save',paziente)
  }
  checkCodiceFiscale(codiceFiscale: string): Observable<boolean> {
    return this.http.get<boolean>(environment.backendUrl+`/paziente/check/${codiceFiscale}`);
  }
  public getPazienteByEhrId(ehrId: string){
    return this.http.get<Paziente>(environment.backendUrl+`/paziente/find/ehrId/${ehrId}`);
  }
  public updatePaziente(paziente: any){
    return this.http.patch<Paziente>(environment.backendUrl+'/paziente/aggiorna',paziente)
  }
}
